import { TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import IosSwitchBtn from "../../../../Component/DigitalMarketing/IosSwitchbtn";
import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../../assets/DigitalMarketing/image/edit.svg";
import AlertDialog from "../../../../Component/DigitalMarketing/deleteConfirmation";
import {
  useAddEHRAdviceMutation,
  useDeleteEHRAdviceMutation,
  useDeleteEHRComplaintsMutation,
  useDeleteEHRDiagnosisMutation,
  useDeleteHandEMutation,
} from "../../../../Service/Masters";
import useDeleteBox from "../../../../hooks/digitalMarketing/useDeleteBox";

const TableList = (props) => {
  const {
    activeIndex,
    complaintsData,
    HandEData,
    adviceData,
    diagnosisData,
    setUpdateData,
    setShow,
    refetch,
    refetchHandE,
    refetchAdvice,
    refetchDiagnosis
  } = props;

  const [checkedStates, setCheckedStates] = useState([]);
  const { open, message, openDelete, deleteId } = useDeleteBox();
  const [deleteComplaints] = useDeleteEHRComplaintsMutation();
  const [deleteHandE] = useDeleteHandEMutation();
  const [deleteAdvice] = useDeleteEHRAdviceMutation();
  const [deleteDiagnosis] = useDeleteEHRDiagnosisMutation();
  const deleteFunctions = {
    1: deleteComplaints,
    2: deleteHandE,
    3: deleteAdvice,
    4: deleteDiagnosis,
  };
  const handleChange = (index) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);
  };

  const handleUpdate = (data) => {
    setUpdateData(data);
    setShow(true);
  };


  const deleteBranches = async (bool) => {
    if (bool) {
      const deleteFunction = deleteFunctions[activeIndex];
      await deleteFunction(deleteId);
      if (activeIndex === 1) {
        refetch(); 
      } else if (activeIndex === 2) {
        refetchHandE(); 
      } else if (activeIndex === 3) {
        refetchAdvice();
      } else if (activeIndex === 4) {
        refetchDiagnosis();
      }
    }
    openDelete("Are you sure you want to delete ?", false, null);
  };

  useEffect(() => {
    const data =
      activeIndex === 1
        ? complaintsData
        : activeIndex === 2
        ? HandEData
        : activeIndex === 3
        ? adviceData
        : diagnosisData;
    if (data?.data) {
      setCheckedStates(data.data.map((a) => a?.activeStatus === 1));
    }
  }, [complaintsData, HandEData, adviceData, diagnosisData, activeIndex]);

  return (
    <>
      <AlertDialog
        open={open}
        message={message}
        deleteBranches={deleteBranches}
      />
      {activeIndex === 1 &&
        complaintsData?.data.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.complaintName}</TableCell>
            <TableCell align="left">{a.complaintsDescription}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index)}
                checked={checkedStates[index] || false}
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this Complaints?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))}
      {activeIndex === 2 &&
        HandEData?.data.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.name}</TableCell>
            <TableCell align="left">{a.description}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index)}
                checked={checkedStates[index] || false}
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this H and E?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))}
      {activeIndex === 3 &&
        adviceData?.data.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.complaint}</TableCell>
            <TableCell align="left">{a.advice}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index)}
                checked={checkedStates[index] || false}
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this Advice?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))}
      {activeIndex === 4 &&
        diagnosisData?.data.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{a.diagnosis}</TableCell>
            <TableCell align="left">{a.icdCode}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index)}
                checked={checkedStates[index] || false}
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursur"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursur action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this Diagnosis?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))}
    </>
  );
};

export default TableList;
